import { SCORE_BANDS, type ScoreBand } from '@cyberscore/contracts';

/** "Very good", as the score's band is named everywhere people read it. */
export const bandLabel = (b: ScoreBand) => b.charAt(0) + b.slice(1).toLowerCase().replace('_', ' ');

/** The tone a band is shown in: poor is bad, fair a warning, the rest good. */
export const bandTone = (b: ScoreBand): 'bad' | 'warn' | 'ok' =>
  b === 'POOR' ? 'bad' : b === 'FAIR' ? 'warn' : 'ok';

export const bandRange = (b: ScoreBand) => {
  const x = SCORE_BANDS.find((s) => s.key === b)!;
  return `${x.min}–${x.max}`;
};

/** Ringgit in a few characters: RM 950, RM 48k, RM 1.2m. */
export function rm(n: number): string {
  const a = Math.abs(n);
  const s =
    a >= 1e6 ? `${trim(a / 1e6)}m` : a >= 1e3 ? `${trim(a / 1e3, a >= 1e5 ? 0 : 1)}k` : `${Math.round(a)}`;
  return `${n < 0 ? '−' : ''}RM ${s}`;
}
const trim = (n: number, digits = 1) => String(Number(n.toFixed(digits)));

export const pct = (share: number) => `${Math.round(share * 100)}%`;

/** A score change with its sign, or an en dash for none. */
export const signed = (n: number | null) =>
  n === null ? '–' : n === 0 ? '0' : `${n > 0 ? '+' : '−'}${Math.abs(n)}`;
